import API from './API'
const route = 'announcement/'

var Announcement = (function () {
  function announcement() {}

  announcement.prototype.create = function (data) {
    return API.post(route, data)
  }

  announcement.prototype.update = function (id, data) {
    return API.put(`${route}${id}`, data)
  }
  announcement.prototype.getList = function () {
    return API.get(`${route}list`)
  }
  announcement.prototype.remove = function (id) {
    return API.delete(`${route}${id}`)
  }

  return announcement
})()
export default Announcement



// WEBPACK FOOTER //
// ./src/assets/js/libs/Announcement.js